(function ($) {
  'use strict';

  $(function () {
    // This asset is loaded only on product pages, but keep the guard for
    // themes/apps that render product markup in another template.
    if (!$('body').hasClass('template-product')) {
      return;
    }

    // Collapse all "What's included" sections initially.
    $('.grid-product .whats-included-heading')
      .removeClass('expand')
      .attr('aria-expanded', 'false')
      .find('.whats-included-heading-icon')
      .removeClass('rotate');
    $('.grid-product .whats-included-content').hide();

    // Toggle the "What's included" accordion.
    $(document)
      .off('click.sgFunctionsProduct', '.whats-included-heading')
      .on('click.sgFunctionsProduct', '.whats-included-heading', function () {
        var $trigger = $(this);
        var $icon = $trigger.find('.whats-included-heading-icon');
        var isExpanded = $trigger.hasClass('expand');

        if (isExpanded) {
          $trigger.removeClass('expand');
          $trigger.next('.whats-included-content').slideUp();
          $trigger.attr('aria-expanded', 'false');
          $icon.removeClass('rotate');
        } else {
          $trigger.addClass('expand');
          $trigger.next('.whats-included-content').slideDown();
          $trigger.attr('aria-expanded', 'true');
          $icon.addClass('rotate');
        }
      });

    // Copy lazy-loaded popup images to their real image attributes when the
    // popup is opened. This works with the markup generated by the product
    // card and does not require newer JavaScript APIs.
    function activatePopupImages($popupContent) {
      if ($popupContent.hasClass('hidden')) {
        return;
      }

      $popupContent.find('source[data-srcset]').each(function () {
        var $source = $(this);

        if (!$source.attr('srcset')) {
          $source.attr('srcset', $source.attr('data-srcset'));
        }
      });

      $popupContent.find('img[data-src]').each(function () {
        var $image = $(this);

        if (!$image.attr('src')) {
          $image.attr('src', $image.attr('data-src'));
        }
      });
    }

    // Open the popup from the information icon.
    $(document)
      .off('click.sgFunctionsProduct', '.whats-included-popup')
      .on('click.sgFunctionsProduct', '.whats-included-popup', function (event) {
        var $popup = $(this);
        var $content = $popup.siblings('.whats-included-popup-content');

        event.stopPropagation();
        $('.whats-included-popup-content').not($content).addClass('hidden');
        $content.toggleClass('hidden');
        activatePopupImages($content);
      });

    // Close the popup from its close button.
    $(document)
      .off('click.sgFunctionsProduct', '[data-close-whats-included-popup]')
      .on('click.sgFunctionsProduct', '[data-close-whats-included-popup]', function (event) {
        event.stopPropagation();
        $(this).closest('.whats-included-popup-content').addClass('hidden');
      });

    // Set image/title clicks open the popup instead of navigating to the set.
    // The complementary grid card uses the data attribute on its image and
    // information wrapper, while the legacy card also has the same attribute.
    $(document)
      .off('click.sgFunctionsProduct', '[data-open-whats-included-popup]')
      .on('click.sgFunctionsProduct', '[data-open-whats-included-popup]', function (event) {
        var $productItem = $(this).closest('.product-item, .grid-product');
        var $content = $productItem.find('.whats-included-popup-content');

        if (!$content.length) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        $('.whats-included-popup-content').not($content).addClass('hidden');
        $content.toggleClass('hidden');
        activatePopupImages($content);
      });

    // Open the popup when clicking the image overlay link on the custom
    // product card (product-card-02_complementary).
    $(document)
      .off('click.sgFunctionsProduct', '.card-link.fdp-set-title-clickable')
      .on('click.sgFunctionsProduct', '.card-link.fdp-set-title-clickable', function (event) {
        var $productItem = $(this).closest('.product-item');
        var $content = $productItem.find('.whats-included-popup-content');

        if (!$content.length) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        $('.whats-included-popup-content').not($content).addClass('hidden');
        $content.toggleClass('hidden');
        activatePopupImages($content);
      });
  });
}(jQuery));